
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'

import type { RegularFilter } from '../../models'
import type { SemanticService } from '../../services/semantic.service'

import { SlidingPanel } from '@empathyco/x-components'

import { QueryPreviewList } from '@empathyco/x-components/queries-preview'
import { defineComponent, getCurrentInstance, onMounted, ref } from 'vue'
import { mapGetters, useInstance } from '../../composables'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { FilterIdEnum } from '../../enums'
import { CONTEXT_CONSTS } from '../../store'
import { EpbText } from '../shared/epb-text'
import SemanticCard from './semantic-card.component.vue'

export default defineComponent({
  name: 'SemanticPreviewList',
  components: { EpbText, QueryPreviewList, SemanticCard, SlidingPanel },
  props: {
    query: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const baseClass = 'semantic-preview-list'

    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const messages = ctx.proxy.$epb.messages.explain

    const semanticsResults = ref([])

    const loading = ref(true)

    const { instanceConfig } = useInstance()

    const {
      context: {
        value: { filters },
      },
    } = mapGetters<Instance>(ctx.proxy.$store, CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    })

    const data = async function (): Promise<void> {
      try {
        const semanticService = CONTAINER.get<SemanticService>(TYPES.SemanticService)

        semanticsResults.value = await semanticService.searchSemantic(instanceConfig.value.id, {
          query: props.query,
          limit: 10,
          lang: (filters[FilterIdEnum.LANG] as unknown as RegularFilter).selectedValues[0],
        })
      } catch (error) {
        semanticsResults.value = []
      }

      loading.value = false
    }

    onMounted(async () => {
      await data()
    })

    return {
      baseClass,
      messages,
      semanticsResults,
      loading,
    }
  },
})
